module.exports = __webpack_public_path__ + "c4d754b22ab69e6d39c33e9b9ab9ec8e.pdf";